/**
 * Aide contextuelle — Section Incidents (Reponse a incidents)
 */

const incidentsHelp = {
  '/incidents': {
    title: 'Gestion des incidents',
    user: [
      {
        heading: 'A quoi sert cette page ?',
        content: `Module de reponse a incidents multi-client. Gerez le cycle complet : detection (monitoring), investigation (SOC) et reponse formelle (dossiers d'incident).`,
      },
      {
        heading: 'Les 3 niveaux',
        content: `**Evenements de monitoring** — Signaux bruts de detection provenant de sources variees (SIEM, EDR, alertes manuelles). A qualifier par un analyste.\n**Cas SOC** — Investigations structurees avec hypotheses, decouvertes et notes d'analyse.\n**Incidents** — Dossiers formels avec coordination multi-equipe, chronologie, preuves et actions.`,
      },
      {
        heading: 'Workflow type',
        content: `1. Un evenement de monitoring arrive.\n2. L'analyste le qualifie : s'il est pertinent, il le **promeut** en incident.\n3. L'incident passe par les phases : qualification → en cours → contenu → resolu → clos.\n4. Tout au long, les actions, communications, decisions et preuves sont consignees dans les **journaux** dedies.`,
      },
      {
        heading: 'Severites',
        content: `**Faible** — Impact limite, pas d'urgence.\n**Moderee** — Impact significatif, traitement dans les delais normaux.\n**Elevee** — Impact majeur, mobilisation rapide requise.\n**Critique** — Impact systemique, mode crise active.`,
      },
      {
        heading: 'Types d\'incidents',
        content: `Ransomware, Phishing, Compromission, Exfiltration de donnees, Malware, Autre.`,
      },
      {
        heading: 'Confidentialite',
        content: `Chaque incident a un niveau de confidentialite : **Normal**, **Confidentiel**, **Secret**, **Tres restreint**. Les niveaux eleves limitent la visibilite aux personnes autorisees.`,
      },
    ],
    admin: [
      {
        heading: 'Architecture multi-journal',
        content: `Chaque incident a 4 journaux distincts, alimentes automatiquement selon le type d'entree :\n\n\`email_recu\` → chronologie + communications\n\`email_envoye\` → chronologie + communications\n\`action_technique\` → chronologie + actions\n\`decision\` → chronologie + decisions\n\`ioc/osint/fait_observe\` → chronologie uniquement`,
      },
      {
        heading: 'Statuts monitoring',
        content: `new → ignored | closed_no_action | qualified | promoted\n\nPromotion = creation d'un incident lie.`,
      },
      {
        heading: 'Statuts incident',
        content: `new → qualified → in_progress → contained → resolved → closed`,
      },
      {
        heading: 'Gestion des preuves',
        content: `L'upload d'une preuve declenche : calcul SHA256, envoi au webhook n8n pour analyse automatique (OCR, classification, lookup de hash). Le callback n8n poste les resultats sur \`/api/n8n/webhook/incident\` (valide par \`X-N8N-Secret\`).\n\nTypes de preuves : email, capture, document, log, export, hash, piece_externe, autre.\nStatut d'analyse : pending → done | error.`,
      },
      {
        heading: 'Endpoints principaux',
        content: `\`GET /api/ir/bootstrap?organization_id=<id>\` — Config + stats + organisations.\n\`GET/POST /api/ir/monitoring-events\` — CRUD monitoring.\n\`GET/POST/PUT/DELETE /api/ir/incidents\` — CRUD incidents.\n\`GET /api/ir/incidents/{id}/chronologie\` — Journal chronologique.\n\`GET /api/ir/incidents/{id}/communications\` — Journal communications.\n\`GET /api/ir/incidents/{id}/actions\` — Journal actions.\n\`GET/POST/PUT/DELETE /api/ir/incidents/{id}/preuves\` — Gestion preuves.`,
      },
      {
        heading: 'Permissions',
        content: `\`incidents.manage\` — Creer, promouvoir, gerer preuves.\n\`superadmin\` — Supprimer incidents/monitoring/SOC cases.`,
      },
    ],
  },
};

export default incidentsHelp;
